// @ts-nocheck

import dash_api from '../support/dash_api';
import { ReduxAsyncAction } from '../support/utils';

export const DataIntegrations = new ReduxAsyncAction('DATA_INTEGRATIONS');
DataIntegrations.registerRequest(() => {
  return dash_api.get('/v1/data-integrations').then(({ data }) => data);
});
export const getDataIntegrations = DataIntegrations.request;
export const DATA_INTEGRATIONS = DataIntegrations.constants;

const SaveDataIntegration = new ReduxAsyncAction('DATA_INTEGRATION_SAVE');
SaveDataIntegration.registerRequest((machineName, body) => {
  return dash_api.post(`/v1/data-integrations/${machineName}`, body).then(({ data }) => data);
});
export const saveDataIntegration = SaveDataIntegration.request;
export const DATA_INTEGRATION_SAVE = SaveDataIntegration.constants;

const SaveEventIngestion = new ReduxAsyncAction('EVENT_INGESTION_SAVE');
SaveEventIngestion.registerRequest((provider, body) => {
  return dash_api.put(`/v1/data-integrations/event-ingestion/${provider}`, body).then(({ data }) => data);
});
export const saveEventIngestion = SaveEventIngestion.request;
export const EVENT_INGESTION_SAVE = SaveEventIngestion.constants;

const UpdateDataIntegration = new ReduxAsyncAction('DATA_INTEGRATION_UPDATE');
UpdateDataIntegration.registerRequest((machineName, body) => {
  return dash_api.put(`/v1/data-integrations/${machineName}`, body).then(({ data }) => data);
});
export const updateDataIntegration = UpdateDataIntegration.request;
export const DATA_INTEGRATION_UPDATE = UpdateDataIntegration.constants;

const DeleteDataIntegration = new ReduxAsyncAction('DATA_INTEGRATION_DELETE');
DeleteDataIntegration.registerRequest((machineName) => {
  return dash_api.delete(`/v1/data-integrations/${machineName}`).then(({ data }) => data);
});
export const deleteDataIntegration = DeleteDataIntegration.request;
export const DATA_INTEGRATION_DELETE = DeleteDataIntegration.constants;

const DisableDataIntegration = new ReduxAsyncAction('DATA_INTEGRATION_DISABLE');
DisableDataIntegration.registerRequest((machineName) => {
  return dash_api.put(`/v1/data-integrations/disable/${machineName}`).then(({ data }) => data);
});
export const disableDataIntegration = DisableDataIntegration.request;
export const DATA_INTEGRATION_DISABLE = DisableDataIntegration.constants;

const OldDataIntegrations = new ReduxAsyncAction('OLD_DATA_INTEGRATIONS');
OldDataIntegrations.registerRequest(() => {
  return dash_api.get('/v1/data-integrations/old').then(({ data }) => data);
});
export const getOldDataIntegrations = OldDataIntegrations.request;
export const OLD_DATA_INTEGRATIONS = OldDataIntegrations.constants;

const DisableOldDataIntegration = new ReduxAsyncAction('OLD_DATA_INTEGRATIONS_DISABLE');
DisableOldDataIntegration.registerRequest((machineName) => {
  const integrationKey = machineName.replace('di_', '');
  return dash_api.put(`/v1/data-integrations/old/disable/${integrationKey}`).then(({ data }) => data);
});
export const disableOldDataIntegration = DisableOldDataIntegration.request;
export const OLD_DATA_INTEGRATIONS_DISABLE = DisableOldDataIntegration.constants;
